import React, { useCallback, useEffect, useState } from 'react';
import TextEditor from '../../../../components/serverDrivenUIComponents/TextEditor';
import { Heading } from '../../../../UiKit';
import { green, grey } from 'sushiweb/tokens/color';
import { Star } from '../../../../UiKit/Star/Star';
import { Button, Input } from '@grofers/react';
import Multiselect from 'multiselect-react-dropdown';
import './form.css';
import { useUpdateAnnouncements } from './apis';
import Spinner from 'sushiweb/Spinner/Spinner';
import { convertLocalDateTimeToUtc } from '../../../../utils/UtilFunctions';

const styles = {
  multiSelectOrganisationDesign: `
    div:first-child() {
      width: 100%;
    }
    #multiselectContainerReact > div.optionListContainer.displayNone {
      display: none !important;
      z-index: 20;
      position: absolute !important;
      margin-top: 2rem;
    }

    .chip {
      background-color: transparent !important;
      font-weight: 400 !important;
      font-size: 1.33rem !important;
      border-radius: 4px;
      padding: 4px 8px;
    }
    .icon_down_dir {
      position: absolute;
      right: 1.5rem;
      z-index: 30;
      top: auto;
      transform: none;
    }
  `,
  headingStyling: `
  div:first-child() {
    width: 100%;
  }
  #multiselectContainerReact
    > div.optionListContainer.displayNone {
    display: none !important;
    z-index: 20;
    position: absolute !important;
    margin-top: 2rem;
  }
  `,
  multiSelectOptionsListDesign: `
  div:first-child() {
    width: 100%;
  }
  #multiselectContainerReact > div.optionListContainer.displayNone {
    display: none !important;
    z-index: 20;
    position: absolute !important;
    margin-top: 2rem;
  }
  `,
  marginStyling: `
    & p {
      margin-bottom: 0 !important;
    }
  `,
};

const UpdateForm = (props) => {
  const {
    getPermissionsList,
    permissionsLoading,
    getOrganisationsList,
    organisationsLoading,
    defaultValues,
    idPermissionMap,
    idOrganisationMap,
    refetchAnnouncements,
    closeUpdateFormPopUp,
  } = props;
  const [formDataToSubmit, setFormDataToSubmit] = useState();
  const { mutate: update, isLoading: isUpdating } = useUpdateAnnouncements({
    onSuccess: () => {
      refetchAnnouncements();
      closeUpdateFormPopUp();
    },
  });

  const getFormattedTsToSend = (timeStamp) => {
    const len = timeStamp?.length;
    let formattedDateTime;
    if (timeStamp?.includes('Z'))
      formattedDateTime = timeStamp?.substr(0, len - 4);
    else formattedDateTime = timeStamp;
    return formattedDateTime;
  };

  const getFormattedTsShow = (timeStamp) => {
    const utcDateObj = new Date(timeStamp);

    const LocalTs = utcDateObj.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'Asia/Kolkata',
    });

    const localdateObj = new Date(LocalTs);

    // Extract the individual components
    const year = localdateObj.getFullYear();
    const month = (localdateObj.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month since it's zero-based
    const day = localdateObj.getDate().toString().padStart(2, '0');
    const hours = localdateObj.getHours().toString().padStart(2, '0');
    const minutes = localdateObj.getMinutes().toString().padStart(2, '0');

    const formattedDatetimeString2 = `${year}-${month}-${day}T${hours}:${minutes}`;
    return formattedDatetimeString2;
  };

  useEffect(() => {
    if (defaultValues?.id) {
      let roles = [];
      const role_ids = defaultValues?.role_ids;
      for (let i = 0; i < role_ids?.length; i++)
        roles = [
          ...roles,
          { id: role_ids?.[i], name: idPermissionMap?.[role_ids?.[i]] },
        ];
      const dataToSubmit = {
        ...defaultValues,
        start_ts: getFormattedTsToSend(defaultValues?.start_ts),
        end_ts: getFormattedTsToSend(defaultValues?.end_ts),
        roles: roles,
        org_id: defaultValues?.org_id,
      };
      setFormDataToSubmit(dataToSubmit);
    }
  }, [defaultValues, idPermissionMap]);

  const handleFormData = (inputKey, value) => {
    const formData = { ...formDataToSubmit, [inputKey]: value };
    setFormDataToSubmit(formData);
  };
  const saveOptions = useCallback(
    (selectedList) => {
      setFormDataToSubmit({ ...formDataToSubmit, roles: selectedList });
    },
    [formDataToSubmit],
  );
  const saveOrganisationOption = useCallback(
    (selectedList, selectedItem) => {
      setFormDataToSubmit({ ...formDataToSubmit, org_id: selectedItem.id });
    },
    [formDataToSubmit],
  );

  const removeOrganisationOption = useCallback(() => {
    setFormDataToSubmit({ ...formDataToSubmit, org_id: null });
  }, [formDataToSubmit]);

  const removeOptions = useCallback(
    (selectedList) => {
      setFormDataToSubmit({ ...formDataToSubmit, roles: selectedList });
    },
    [formDataToSubmit],
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    update(formDataToSubmit);
  };

  const getPreSelectedRoles = () => {
    const len = defaultValues?.role_ids?.length;
    let roles = [];
    for (let i = 0; i < len; i++) {
      const id = defaultValues?.role_ids?.[i];
      roles = [...roles, { name: idPermissionMap?.[id], id: id }];
    }
    return roles;
  };

  const getPreSelectedOrganisation = () => {
    const orgId = defaultValues?.org_id;
    const orgName = idOrganisationMap?.[orgId];
    return [{ name: orgName, id: orgId }];
  };

  const isValid = () => {
    const isAllField =
      formDataToSubmit?.announcement_text?.length &&
      formDataToSubmit?.start_ts &&
      formDataToSubmit?.end_ts &&
      formDataToSubmit?.roles?.length;
    return isAllField ? true : false;
  };

  if (permissionsLoading)
    return (
      <div className='tw-w-full tw-flex tw-justify-center tw-items-center'>
        <Spinner color={green.z700} />
      </div>
    );

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-4 tw-z-50'>
      <form className='tw-bg-white tw-rounded-2xl tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-6 tw-relative tw-mb-[20rem] '>
        <label
          htmlFor='ann_text_editor'
          className='tw-w-full tw-flex tw-flex-col tw-gap-1'
        >
          <div className='tw-flex'>
            <Heading
              title={'Announcement Text'}
              color='#1F1F1F'
              weight='600'
              size='17px'
            />

            <Star icon='*' />
          </div>
          <TextEditor
            styleClasses='tw-w-full tw-flex tw-flex-wrap tw-text-wrap'
            id='ann_text_editor'
            field={{ value: defaultValues?.announcement_text }}
            inputKey={'announcement_text'}
            saveOptions={handleFormData}
          />
        </label>
        <div className='tw-w-full tw-flex-col tw-flex tw-gap-2 tw-justify-evenly '>
          <label
            htmlFor='customerIdInput'
            className='tw-w-full tw-flex tw-flex-col tw-gap-1'
          >
            <div className='tw-flex'>
              <Heading
                title={'Start Timestamp'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />

              <Star icon='*' />
            </div>
            <Input
              style={{
                padding: '1.22rem 1rem',
                fontWeight: '400',
                fontSize: '1.33rem',
              }}
              type='datetime-local'
              defaultValue={getFormattedTsShow(defaultValues?.start_ts)}
              onChange={(e) => {
                handleFormData(
                  'start_ts',
                  convertLocalDateTimeToUtc(e.target.value),
                );
              }}
            />
          </label>
          <label
            htmlFor='customerIdInput'
            className='tw-w-full tw-flex tw-flex-col tw-gap-1'
          >
            <div className='tw-flex'>
              <Heading
                title={'End Timestamp'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />

              <Star icon='*' />
            </div>
            <Input
              style={{
                padding: '1.22rem 1rem',
                fontWeight: '400',
                fontSize: '1.33rem',
              }}
              type='datetime-local'
              defaultValue={getFormattedTsShow(defaultValues?.end_ts)}
              onChange={(e) => {
                handleFormData(
                  'end_ts',
                  convertLocalDateTimeToUtc(e.target.value),
                );
              }}
            />
          </label>
          <label
            htmlFor='customerIdInput'
            className='tw-w-full tw-flex tw-flex-col tw-gap-1'
            css={styles.multiSelectOptionsListDesign}
          >
            <div className='tw-w-full tw-flex ' css={styles.headingStyling}>
              <Heading
                title={'Roles'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <Multiselect
              showCheckbox
              selectedValues={getPreSelectedRoles()}
              avoidHighlightFirstOption
              singleSelect={false}
              loading={permissionsLoading}
              placeholder='Search roles...'
              options={getPermissionsList}
              onSelect={saveOptions}
              onRemove={removeOptions}
              displayValue='name'
            />
          </label>
          <label
            htmlFor='customerIdInput'
            className='tw-w-full tw-flex tw-flex-col tw-gap-1'
            css={styles.multiSelectOrganisationDesign}
          >
            <div className='tw-w-full tw-flex ' css={styles.headingStyling}>
              <Heading
                title={'Organisations'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
              <Star icon='*' />
            </div>
            <Multiselect
              showCheckbox
              selectedValues={getPreSelectedOrganisation()}
              avoidHighlightFirstOption
              singleSelect={true}
              loading={organisationsLoading}
              placeholder='Search organisations...'
              options={getOrganisationsList}
              onSelect={saveOrganisationOption}
              onRemove={removeOrganisationOption}
              displayValue='name'
            />
          </label>
        </div>
        <div className='tw-flex tw-justify-between tw-w-full'>
          <Button
            onClick={handleSubmit}
            size='medium'
            variant='fill'
            style={{ padding: '1rem 1.7rem' }}
            className='tw-h-14 tw-w-28 tw-mt-4 '
            disabled={!isValid(formDataToSubmit)}
          >
            {isUpdating ? (
              <Spinner size='small' color={`${grey.z300}`} />
            ) : (
              'Submit'
            )}
          </Button>
          <div className='tw-flex tw-items-center tw-gap-2'>
            <div
              className='tw-flex tw-items-center tw-justify-center'
              css={styles.marginStyling}
            >
              <Heading
                title={'Enable/Disable'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
            </div>
            <label className='switch tw-flex tw-gap-1'>
              <input
                type='checkbox'
                onChange={(e) => {
                  handleFormData('is_enabled', e.target.checked);
                }}
                defaultChecked={defaultValues?.is_enabled}
              />
              <span className='slider round'></span>
            </label>
          </div>
        </div>
      </form>
    </div>
  );
};
export default UpdateForm;
